// vire: after removing service worker on devices previously using svc worker
// we need to purge otherwise it will still try to use cached versions
const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations => {
        for (const registration of registrations) {
          registration.unregister().catch(error => {
            // tslint:disable-next-line:no-console
            console.error(`registration.unregister() failed: ${error}`)
          })
        }
      })
      .catch(error => {
        // tslint:disable-next-line:no-console
        console.error(`unregisterServiceWorker failed: ${error}`)
      })
  }
}

export default unregisterServiceWorker



// WEBPACK FOOTER //
// ./src/unregisterServiceWorker.ts